module.exports = __webpack_public_path__ + "img/imac-1.4e45f711.jpg";